import React, { useState, useEffect } from "react";
import "./AddService.css";
import { useDispatch, useSelector } from "react-redux";
import {
  ShowAllCategories,
  ShowOneVendorDetail,
} from "../../../../context/Slice/VendorManagementSlice";
import { useNavigate } from "react-router-dom";
import { AddServices } from "../../../../context/Slice/ServiceManagementSlice";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";
import { lookup } from "../Profile/index.js";
import BusinessDetailsForm from "./vendorCommonDetails.js";
import axios from "axios";
import Select from "react-select";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import DynamicFormFields from "./DynamicFormField.js";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AddService = ({ allUsers }) => {
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({
    id: "",
    OwnerName: "",
    OwnerEmail: "",
    OwnerMobile_number: "",
    BusinessName: "", // Name of the company
    OwnerWhatsapp_number: "",
    useMobileForWhatsapp: false,
    OwnerADDRESS: "",
    OwnerCity: "",
    serviceLocations: [], // Serviced locations
    SocialMediaHandle: [{ platform: "", url: "" }], // PREFERRED SOCIAL MEDIA AND ITS HANDLE/LINK
    ServiceDescription: "",
    // vendorRating: '',
    // enquiryCount: '',
    availableDays: [], // For vendor's availability slots
    BannerImage: null,
    images: [],
    video: [],
    ServiceCategory_ID: "",
    ServiceCategory_Name: "",
    dynamicFields: {}, // Stores dynamic field values
  });
  const [pinCodeError, setPinCodeError] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [categories, setCategories] = useState([]); // Stores all categories
  const [categoryFields, setCategoryFields] = useState([]); // Stores fields of the selected category
  const navigate = useNavigate();
  const [selectedEventCategory, setSelectedEventCategory] = useState([]);

  const [selectedArtist, setSelectedArtist] = useState("");
  const token = secureLocalStorage.getItem("token");
  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);

        dispatch(ShowOneVendorDetail(decoded._id)).then((response) => {
          if ( 
            !response.payload ||
            !response.payload.Vendordetail ||
            response.payload.Vendordetail.length === 0
          ) {
            // If the response is empty or doesn't contain details
            setShowModal(true); // Show the modal if the profile is incomplete
          } else {
            setFormValues((prev) => ({
              ...prev,
              id: decoded._id,
              OwnerName: response.payload.Vendordetail[0].OwnerName,
              OwnerEmail: response.payload.Vendordetail[0].OwnerEmail,
              OwnerMobile_number:
                response.payload.Vendordetail[0].OwnerMobile_number,
              OwnerWhatsapp_number:
                response.payload.Vendordetail[0].OwnerWhatsapp_number,
              BusinessName: response.payload.Vendordetail[0].BusinessName,
              OwnerCity: response.payload.Vendordetail[0].OwnerCity,
              OwnerADDRESS: response.payload.Vendordetail[0].OwnerADDRESS,
            }));
          }
        });
      } catch (error) {
        console.error("Invalid token", error);
      }
    }

    dispatch(ShowAllCategories());
  }, [dispatch, token]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/v1/VendorManagement/show-Categories`
        );
        console.log("Categories fetched:", response.data.data.ShowAllCategorie); // Debug log
        setCategories(response.data.data.ShowAllCategorie || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormValues((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };
  const handleChange = (event) => {
    const { name, value, files, options, multiple } = event.target;
    if (name === "ServiceCategory_ID") {
    } else if (name === "useMobileForWhatsapp") {
      setFormValues((prev) => ({
        ...prev,
        useMobileForWhatsapp: !prev.OwnerWhatsapp_number,
        OwnerWhatsapp_number: !prev.useMobileForWhatsapp
          ? prev.mobileNumber
          : "",
      }));
    } else if (multiple && options) {
      const selectedOptions = Array.from(options)
        .filter((opt) => opt.selected)
        .map((opt) => opt.value);
      setFormValues((prev) => ({ ...prev, [name]: selectedOptions }));
    } else if (name === "images" && multiple) {
      const updatedImages = [...formValues.images, ...Array.from(files)].slice(
        0,
        9
      );
      setFormValues((prev) => ({
        ...prev,
        images: updatedImages,
      }));

      console.log("Updated Images:", updatedImages); // Log to check the stored images
      setFormValues((prev) => ({
        ...prev,
        images: updatedImages,
      }));
    } else if (name === "video") {
      const updatedVideos = [...formValues.video, ...Array.from(files)].slice(
        0,
        2
      );
      console.log("Updated Videos:", updatedVideos); // Log to check the stored videos
      setFormValues((prev) => ({
        ...prev,
        video: updatedVideos,
      }));
    } else if (name === "BannerImage") {
      setFormValues((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormValues((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleCustomSelectChange = (name, selectedValues) => {
    setFormValues((prev) => ({ ...prev, [name]: selectedValues }));
  };

  const handlePinCodeChange = (e) => {
    const input = e.target.value;

    if (!input) return;
    const results = lookup(input);
    const filteredResults = results.filter((location) => {
      return (
        location.stateName
          .toLowerCase()
          .includes(formValues.OwnerCity.toLowerCase()) ||
        location.districtName
          .toLowerCase()
          .includes(formValues.OwnerCity.toLowerCase())
      );
    });

    setSuggestions(filteredResults);
    setShowSuggestions(filteredResults.length > 0);
  };

  const handleSuggestionClick = (suggestion) => {
    setFormValues((prev) => ({
      ...prev,
      serviceLocations: [...prev.serviceLocations, suggestion],
    }));
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    const selectedCategory = categories.find(
      (cat) => cat.id === selectedCategoryId
    );

    setFormValues((prev) => ({
      ...prev,
      ServiceCategory_ID: selectedCategoryId,
      ServiceCategory_Name: selectedCategory
        ? selectedCategory.CategorieName
        : "",
    }));

    setCategoryFields(
      selectedCategory &&
        Array.isArray(JSON.parse(selectedCategory.CategorieFields))
        ? JSON.parse(selectedCategory.CategorieFields)
        : []
    );
  };

  const handleDynamicFieldChange = (fieldName, value) => {
    setFormValues((prev) => ({
      ...prev,
      dynamicFields: {
        ...prev.dynamicFields,
        [fieldName]: value,
      },
    }));
    if (fieldName === "EVENTSCATEGORY") {
    setSelectedEventCategory(value); 
  }

  // Update selected artist category
  if (fieldName === "ARTIST CATEGORY") {
    setSelectedArtist(value);
  }

  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    const commonFields = [
      "id",
      "OwnerName",
      "OwnerEmail",
      "BusinessName",
      "OwnerMobile_number",
      "OwnerWhatsapp_number",
      "ServiceCategory_ID",
      "ServiceCategory_Name",
      "ServiceDescription",
    ];

    commonFields.forEach((field) => formData.append(field, formValues[field]));

    formValues.availableDays.forEach((day, index) => {
      formData.append(`AvailableDays[${index}]`, day);
    });

    formData.append(
      "ServiceLocations",
      JSON.stringify(formValues.serviceLocations)
    );
    formData.append(
      "SocialMediaHandle",
      JSON.stringify(formValues.SocialMediaHandle
        )
    );
    formData.append("Location", formValues.OwnerADDRESS);
    formData.append("City", formValues.OwnerCity);
    formData.append("CompanyName", formValues.BusinessName);
    formData.append("BannerImage", formValues.BannerImage);

    // Handle images and videos as before
    if (Array.isArray(formValues.images)) {
      formValues.images.forEach((image) => {
        formData.append(`Images`, image);
      });
    }
    formValues.video.forEach((vid) => {
      formData.append("Video", vid);
    });

    // Handle Total Budget and Special Badges separately
    if (formValues.dynamicFields["TotalBudget"]) {
      formData.append("TotalBudget", formValues.dynamicFields["TotalBudget"]);
    }

    if (formValues.dynamicFields["SpecialBadges"]) {
      formData.append(
        "SpecialBadges",
        JSON.stringify(formValues.dynamicFields["SpecialBadges"])
      );
    }

    // Collect other dynamic fields under dynamicData and stringify them
    const dynamicData = {};
    Object.entries(formValues.dynamicFields).forEach(([key, value]) => {
      if (key !== "TotalBudget" && key !== "SpecialBadges") {
        dynamicData[key] = value;
      }
    });

    formData.append("DynamicData", JSON.stringify(dynamicData));

    try {
      const response = await dispatch(AddServices(formData));
      console.log("Service added successfully:", response);
    } catch (error) {
      console.error("Error adding service:", error);
    }
  };

  const HandleBack = () => {
    console.log("Back button clicked");
    navigate("/vendor-dashboard");
  };

  return (
    <div className="add-service-body center">
      {/* Back Button */}
      <Button
        variant="contained"
        color="secondary"
        onClick={HandleBack}
        sx={{ position: "absolute", top: "20px", left: "20px" }}
      >
        Back
      </Button>
      <Dialog open={showModal} onClose={() => setShowModal(false)}>
        <DialogTitle>Profile Incomplete</DialogTitle>
        <DialogContent>
          Your profile details are incomplete. Please update your profile before adding a service.
        </DialogContent>
        <DialogActions>
        
          <Button onClick={() => navigate("/vendor-dashboard/Profile")} color="primary">
            Update Profile
          </Button>
        </DialogActions>
      </Dialog>
      <div className="container px-4 mt-4">
        <h2>Add Service Details</h2>
      </div>
      <div className="row justify-content-center">
        <div className="col-xl-8">
          <form onSubmit={handleSubmit}>
            <BusinessDetailsForm
              formValues={formValues}
              setFormValues={setFormValues}
              handleChange={handleChange} // Make sure this is passed
              handlePinCodeChange={handlePinCodeChange}
              pinCodeError={pinCodeError}
              showSuggestions={showSuggestions}
              suggestions={suggestions}
              handleSuggestionClick={handleSuggestionClick}
            />
            <div className="form-group text-center">
              <label>Service Category</label>
              <select
                className="form-control"
                name="ServiceCategory_ID"
                value={formValues.ServiceCategory_ID}
                onChange={handleCategoryChange}
                required
              >
                <option value="">Select a category</option>
                {categories?.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.CategorieName}
                  </option>
                ))}
              </select>
            </div>
            <DynamicFormFields
  categoryFields={categoryFields}
  formValues={formValues}
  handleDynamicFieldChange={handleDynamicFieldChange}
  selectedArtist={selectedArtist}
  selectedEventCategory={selectedEventCategory}
/>
            {/* {Array.isArray(categoryFields) &&
              categoryFields.map((field, index) => (
                <div className="form-group" key={index}>
                  <label>{field.fieldLabel}</label>
                  {field.fieldType === "text" ||
                  field.fieldType === "number" ? (
                    <input
                      className="form-control"
                      type={field.fieldType}
                      name={field.fieldLabel}
                      value={formValues.dynamicFields[field.fieldName] || ""}
                      onChange={(e) =>
                        handleDynamicFieldChange(
                          field.fieldName,
                          e.target.value
                        )
                      }
                    />
                  ) : field.fieldType === "select" ? (
                    <select
                      className="form-control"
                      name={field.fieldName}
                      value={formValues.dynamicFields[field.fieldName] || ""}
                      onChange={(e) =>
                        handleDynamicFieldChange(
                          field.fieldName,
                          e.target.value
                        )
                      }
                    >
                      <option value="">Select</option>
                      {field.options.map((option, optIndex) => (
                        <option key={optIndex} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  ) : field.fieldType === "multiselect" ? (
                    <Select
                    isMulti
                    name={field.fieldName}
                    options={field.options.map((option) => ({
                      value: option,
                      label: option,
                    }))}
                    value={(
                      formValues.dynamicFields[field.fieldName] || []
                    ).map((selectedOption) => ({
                      value: selectedOption,
                      label: selectedOption,
                    }))}
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions.map((opt) => opt.value);
                      handleDynamicFieldChange(field.fieldName, selectedValues);
                    }}
                    closeMenuOnSelect={false}
                    className="basic-multiselect"
                    classNamePrefix="select"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
                    }}
                  />
                  
                  ) : null}
                </div>
              ))} */}

            <button className="btn btn-save" type="submit">
              Save Service
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddService;
